import type { CSSProperties, ReactNode } from "react";

/** Design-handoff Tag: tinted background pill with optional dot indicator.
 *  Distinct from the legacy `../Tag.tsx` which uses transparent bg + border.
 */
export function Tag({
  children,
  color,
  dot = false,
  mono = true,
  style,
}: {
  children: ReactNode;
  /** Color token (e.g. "spec", "aws", "ok", "warn"). Omit for neutral. */
  color?: string;
  /** Show a leading dot indicator. */
  dot?: boolean;
  /** Use mono font (default true; matches design). */
  mono?: boolean;
  style?: CSSProperties;
}) {
  const tint = color ? `var(--${color}-tint)` : "var(--card)";
  const deep = color ? `var(--${color}-deep)` : "var(--ink-2)";
  const border = color
    ? `color-mix(in oklab, var(--${color}) 35%, transparent)`
    : "var(--rule)";
  return (
    <span
      className="tag"
      style={{
        background: tint,
        color: deep,
        borderColor: border,
        fontFamily: mono ? "var(--mono)" : "var(--sans)",
        ...style,
      }}
    >
      {dot && (
        <span
          className="dot"
          style={{
            background: color ? `var(--${color})` : "var(--ink-3)",
          }}
        />
      )}
      {children}
    </span>
  );
}
